import script from "./Volume.vue?vue&type=script&lang=ts&setup=true"
export * from "./Volume.vue?vue&type=script&lang=ts&setup=true"

import "./Volume.vue?vue&type=style&index=0&id=4c1093ed&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1093ed"]])

export default __exports__